import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const employeeTasks = {
  get: async (params?: any) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/employee-tasks`, {
        params,
      });
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  getTechnicalRaw: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/employee-tasks/technical/raw`);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  getCigarProductionScheduleTasks: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/employee-tasks/cigar-production-schedule-tasks`);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  getHistory: async (id: string) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/employee-tasks/${id}/history`);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  updateStatus: async (id: string, data: { status: string; notes?: string }) => {
    try {
      const res = await axiosApiInstance.patch(`${apiRoot}/employee-tasks/${id}/status`, data);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  createCycleCount: async (id: string, data?: { assignedUser?: string; rooms?: string[]; dueDate?: string }) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/employee-tasks/${id}/cycle-count`, data);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  createCigarProductionScheduleTask: async (id: string, data?: { assignedUser?: string; dueDate?: string }) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/employee-tasks/${id}/cigar-production-schedule-task`, data);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  createTobaccoProductionPlanningTask: async (id: string, data?: { assignedUser?: string; dueDate?: string }) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/employee-tasks/${id}/tobacco-production-planning-task`, data);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  createSimple: async (data: { assignedUser: string; title: string; description?: string; dueDate?: string }) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/employee-tasks`, data);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  updateSimple: async (
    id: string,
    data: { assignedUser: string; title: string; description?: string; dueDate?: string }
  ) => {
    try {
      const res = await axiosApiInstance.patch(`${apiRoot}/employee-tasks/${id}`, data);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  archive: async (id: string) => {
    try {
      const res = await axiosApiInstance.patch(`${apiRoot}/employee-tasks/${id}/archive`);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
  remove: async (id: string) => {
    try {
      const res = await axiosApiInstance.delete(`${apiRoot}/employee-tasks/${id}`);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default employeeTasks;
